import axios from 'axios';
import { jsonToGraphQLQuery } from 'json-to-graphql-query';
import { AUTH_BASE } from 'api/constants';

export function revokeSession(refreshToken, accessToken) {
  if (!refreshToken) {
    return Promise.resolve();
  }

  const query = jsonToGraphQLQuery({
    mutation: {
      logout: {
        __args: {
          token: refreshToken,
        },
      },
    },
  }, { pretty: true });

  return axios({
    method: 'POST',
    url: AUTH_BASE,
    headers: {
      'content-type': 'application/json',
      authorization: accessToken ? `Bearer ${accessToken}` : undefined,
    },
    data: {
      variables: {},
      query,
    },
  });
}
